import "./Typeform.scss";

import React from "react";

import { Widget } from "@typeform/embed-react";

interface TypeformProps {
  variant?: "Default";
}

const Typeform: React.FC<TypeformProps> = ({ variant = "Default" }) => {
  return <Widget id="TZzAvaGu" className="typeform" />;
};

export default Typeform;
